import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Bitbucket = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.2 32A16 16 0 006 47.8a26.35 26.35 0 00.2 2.8l67.9 412.1a21.77 21.77 0 0021.3 18.2h325.7a16 16 0 0016-13.4L505 50.7a16 16 0 00-13.2-18.3 24.58 24.58 0 00-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
  }));
});
Bitbucket.displayName = 'Bitbucket';
export var BitbucketDimensions = {
  height: 512,
  width: 512
};